{
    "simulationList": [],
    "simulationTotalCount": 0,
    "simulationErrorsCount": 0,
    "simulationSortExpression": null,
    "simulationFilterExpression": null,
    "productIndividual": {},
    "simulationPaging": {
      "offset": 50,
      "page": 1
    },
    "currentColumns": [
        "simProdNumber",
        "partPeriod",
        "xCorrelationId",
        "structMarketCOReleaseTime",
        "userId",
        "status",
        "baseCost",
        "createdOn",
        "updatedOn",
        "sportMessage",
        "errorMessage"
    ]
  }